import React from "react";
import { Helmet } from 'react-helmet-async';
import debounce from 'debounce'
import { Route, Link, withRouter } from "react-router-dom";
import LocationComponent from "../location_component";
import ServicesSelectionComponent from "./services_selection_component_2";
import ServiceChoiceComponent from "./service_choice_component";
import PhotographerSelectionComponent from "../create_project/photographer_selection_component";
import OrderSummaryComponent from "../create_project/order_summary_component";
import CreateProjectModal from "../create_project/create_project_modal_container";
import AccountRequiredModal from "../create_project/account_required_modal";
import { fetchUserPromos } from "../../util/settings_api_util";
import ProjectCreatedModal from "../create_project/project_created_modal";
import smallMobileLogo from "../../../../assets/images/smallMobileLogo";
import {ReactComponent as CloseIcon} from '../../../../assets/images/close-icon.svg'
import ContractorCalendarModal from "../create_project/contractor_calendar_component_container";
import ChooseTimeModal from "../create_project/choose_time_modal";
import BundleReplacedModal from "../create_project/bundle_replaced_modal";
import AddMoreServicesHomepageModal from "../create_project_home_page/add_more_services_homepage_modal";
import { fetchTimeSlots, fetchSettings } from "../../util/settings_api_util";
import { fetchBundleGroups } from "../../util/bundle_api_utils";
import {formatDatetime} from "../../util/date_util";
import { fetchUnavailability } from "../../util/project_api_util";
import AddonSubServicesSelectionComponent from "./addon_subservices_selection_component"
import { fetchLocationSubServices } from "../../util/service_api_util";
import { detectTimezone } from "../../util/timezone_utils"
import ScrollArrows from "../scroll_arrows"

class CreateProjectMain2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      county: "",
      street: "",
      apartment: "",
      zipcode: "",
      state: "",
      city: "",
      latitude: "",
      longitude: "",
      formatted_address: "",
      note: "",
      sub_broker_client: "",
      sub_broker_client_info: {},
      client_role: "",
      user_emails: [],
      client_timezone: undefined,
      photographer: "",
      promos: [],
      promo_price: "",
      loading: true,
      bundleLoading: true,
      promo_name: "",
      currentlySelectedService: null,
      emails: [],
      package_attributes: {},
      selectedSubservices: {},
      cancelledPackages: {},
      appointments: {},
      selected_service: -1,
      specific_service: -1,
      selected_bundle: {},
      bundle_groups: [],
      main_service: {},
      previouslyChosen: {},
      visitedServices: {},
      visitedAppointments: {},
      discount: 0,
      waiting: false,
      modalOpen: false,
      contractorModalOpen: false,
      chooseTimeModalOpen: false,
      bundleReplacedModalOpen: false,
      goingBackToAddress: false,
      bundleSelected: false,
      alacartSelected: true,
      addonSubServices: false,
      new_order_process: true,
      bundleDiscountWith2: 0,
      bundleDiscountWith3: 0,
      bundleDiscountWith4: 0,
      long_shoot: null,
      account_credit: this.props.currentUser?.account_credit?.amount,
      account_credit_id: "",
      contractorSearch: "",
      contractorDateSearch: "",
      contractorTimeSearch: "",
      twilight_time: "",
      firm: {},
      project: {},
      users: {},
      errors: [],
      propertyErrors: [],
      summaryErrors: [],
      time_slots: { "Sunday": {}, "Monday": {}, "Tuesday": {}, "Wednesday": {}, "Thursday": {}, "Friday": {}, "Saturday": {} },
      page: 1,
      coupon: {},
      location_pricing: {},
      detected_timezone: ""
    }

    this.handler = this.handler.bind(this)
    this.setAppointmentTime = this.setAppointmentTime.bind(this)
    this.submitOrder = this.submitOrder.bind(this)
    this.previewOrder = this.previewOrder.bind(this)
    this.deleteSubService = this.deleteSubService.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrevious = this.handlePrevious.bind(this)
    this.calculatePrice = this.calculatePrice.bind(this)
    this.calculateOriginalPrice = this.calculateOriginalPrice.bind(this)
    this.debounceFetchContractors = debounce((service, zip, search, date, time, services, appointments, timezone, photographer_index, long_shoot) => this.props.fetchContractors(service, zip, search, date, time, services, appointments, timezone, photographer_index, long_shoot), 500)
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    this.props.fetchServices().then(() => {
      if (this.props.currentUser.roles.broker || (this.props.currentUser.roles.sub_broker && this.props.currentUser.firm?.broker_charge)) {
        fetchUserPromos(this.props.currentUser.id).then(promos => this.setState({ promos: Object.values(promos) }))
      }
      this.props.fetchCurrentUser(this.props.currentUser.id).then(user => {
        if (!user.user.firm?.broker_charge) {
          this.setState({ account_credit: user.user?.account_credit?.amount, user_emails: user.user?.invites, loading: false})
        } else {
          this.setState({ account_credit: null, user_emails: user.user?.invites, loading: false })
        }
      })
    })

    fetchSettings().then(data => {
      this.setState({
        new_order_process: data.new_order_process,
        bundleDiscountWith2: data.bundle_discount_with_2,
        bundleDiscountWith3: data.bundle_discount_with_3,
        bundleDiscountWith4: data.bundle_discount_with_4,
        page: data.new_order_process ? this.state.page : 0,
        alacartSelected: data.new_order_process ? true : false
      });
    });

    fetchBundleGroups().then(bundle_groups => this.setState({ bundle_groups: bundle_groups, bundleLoading: false }))

    fetchTimeSlots(true).then(time_slots => {
      this.setState({twilight_time: time_slots})
    })

    this.unblock = this.props.history.block((location, action) => {
      if (action === 'POP') {
        if (this.state.page > 0) {
          this.handlePrevious();
        } 
        return false;
      }
      return true;
    });

    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
    document.body.style.overflow = 'unset';
  }


  componentDidUpdate(_, prevState) {
    if (prevState.page !== this.state.page && this.state.page !== 3) {
      this.scrollToStep()
    }

    if (prevState.currentlySelectedService !== this.state.currentlySelectedService) {
      this.scrollToStep()
    }

    if (prevState.county !== this.state.county){
      if (this.state.county != ""){
        const locationKey = this.state.county && this.state.state ? `${this.state.county}, ${this.state.state}` : this.state.county
        fetchLocationSubServices(locationKey).then(location_pricing => {
          this.setState({location_pricing: location_pricing})
        })
      } else {
        this.setState({location_pricing: {}})
      }
    }

    if (prevState.contractorSearch !== this.state.contractorSearch) {
      this.debounceFetchContractors(this.state.selected_service, this.state.zipcode, this.state.contractorSearch, this.state.contractorDateSearch, this.state.contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot)
    }

    if (((prevState.contractorDateSearch !== this.state.contractorDateSearch || prevState.contractorTimeSearch !== this.state.contractorTimeSearch) && !this.state.waiting)) {
      this.setState({ waiting: true })
      this.props.fetchContractors(this.state.selected_service, this.state.zipcode, this.state.contractorSearch, this.state.contractorDateSearch, this.state.contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot).then(() => { this.setState({ waiting: false }) })
    }

    if (prevState.sub_broker_client !== this.state.sub_broker_client && (this.state.client_role === "broker" || this.state.client_role === "sub_broker")) {
      if (this.state.client_role === "sub_broker" && !this.state.firm?.broker_charge) {
        this.setState({ promos: [] })
      } else {
        fetchUserPromos(this.state.sub_broker_client).then(promos => this.setState({ promos: Object.values(promos) }))
      }
    } else if (prevState.sub_broker_client !== this.state.sub_broker_client && (this.state.client_role != "broker" && this.state.client_role != "sub_broker")) {
      this.setState({ promos: [] })
    }

    if (JSON.stringify(Object.keys(prevState.package_attributes || {}).sort()) !== JSON.stringify(Object.keys(this.state.package_attributes || {}).sort())){
      const package_attributes_keys = Object.keys(this.state.package_attributes || {})
      if (package_attributes_keys.length > 3 && this.state.long_shoot === null){
        const requiredTitles = ["Floor Plans", "Video", "Photography", "Drone"];
        const serviceTitles = package_attributes_keys.map(s => this.props.services[s]?.title) || [];
        const hasAllRequired = requiredTitles.every(title => serviceTitles.includes(title));

        if (hasAllRequired) {
          this.setState({long_shoot: true})
        }
      }

      if (this.state.long_shoot){
        const requiredTitles = ["Floor Plans", "Video", "Photography", "Drone"];
        const serviceTitles = package_attributes_keys.map(s => this.props.services[s]?.title) || [];
        const hasAllRequired = requiredTitles.every(title => serviceTitles.includes(title));

        if (!hasAllRequired) {
          this.setState({long_shoot: null})
        }
      }
    }
  }

  scrollToStep() {
    setTimeout(() => {
      const modalContent = document.querySelector('.create-project-homepage-modal .addServiceModalContent')
      if (modalContent) {
        modalContent.scrollTop = 0
      } else {
        const el = document.querySelector('#scrollToHere')
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - 20
          window.scrollTo({ top, behavior: 'smooth' })
        }
      }
    }, 100)
  }

  anyServiceSelected() {
    return Object.keys(this.state.selectedSubservices).length > 0
  }

  handleNext() {
    if (this.state.bundleSelected && this.state.new_order_process) {
      window.location.reload()
      return
    }
    this.setState({ errors: [], summaryErrors: [] })

    let errors = []

    if (this.state.page === 0) {
      if (!this.state.alacartSelected && !this.state.bundleSelected) {
        errors.push("Please select an option before continuing")
      }
    }

    if (this.state.page === 1) {
      // if (this.state.street === "") {
      //   errors.push([1, "Street can't be blank."])
      // }

      if (this.state.street === "") {
        errors.push([1, "Address must be selected from dropdown"])
      }

      if (this.state.city === "") {
        errors.push([2, "City name can't be blank"])
      }

      if (this.state.state === "") {
        errors.push([3, "State can't be blank"])
      }

      if (this.state.zipcode === "") {
        errors.push([4, "Zipcode can't be blank"])
      }
    }
    if (this.state.page === 2) {
      if ((!this.anyServiceSelected() && this.state.alacartSelected) || Object.values(this.state.package_attributes).length === 0) {
        errors.push("Please select a service before continuing")
      }
    }

    if (this.state.page === 4) {
      if (!this.state.appointments[this.state.selected_service]) {
        errors.push("You must select an appointment time before continuing")
      }
    }

    if (errors.length > 0 && this.state.page === 1) {
      this.setState({ propertyErrors: errors })
    } else if (errors.length > 0) {
      this.setState({ summaryErrors: errors })
    }
    else {
      if (this.state.page === 1 && this.state.goingBackToAddress) {
        this.setState({ page: 5, errors: [], summaryErrors: [], propertyErrors: [] })
        // this.debouceScrollTo('#scrollToHere')
      } 
      else if (this.state.page === 1) {
        this.setState({
          page: 2,
          errors: [],
          summaryErrors: [],
          propertyErrors: []
        }, () => {
          // Do timezone detection *after* React has committed page 2
          detectTimezone(this.state.latitude, this.state.longitude)
            .then(detected_timezone => {
              fetchTimeSlots(true, detected_timezone).then(time_slots => {
                this.setState({
                  twilight_time: time_slots,
                  detected_timezone
                });
              });
            });
        })
      }
      else {
        if (this.state.page === 4 || this.state.page === 2 || (this.state.page === 3 && this.state.new_order_process)) {
          if (Object.values(this.state.appointments).length === Object.values(this.state.package_attributes).length) {
            if (this.state.new_order_process) {
              if (Object.values(this.state.visitedServices).length < Object.values(this.state.package_attributes).length) {
                const selectedService = Object.keys(this.state.package_attributes)
                  .map(serviceId => ({
                    id: serviceId,
                    sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
                  }))
                  .filter(service => !this.state.visitedServices[service.id]) // Exclude visited services
                  .reduce((lowest, service) => (service.sort_order < lowest.sort_order ? service : lowest), { sort_order: Infinity })
                  .id || null;


                const updatedVisitedServices = {
                  ...this.state.visitedServices,
                  [selectedService]: true
                };

                this.setState({
                  selected_service: selectedService, currentlySelectedService: this.props.services[selectedService], visitedServices: updatedVisitedServices
                })

              }
              else if (this.state.page === 2) {
                this.setState({ page: 3 })
              } else {
                this.setState({ page: 5, errors: [], summaryErrors: [], propertyErrors: [], currentlySelectedService: null, selected_service: -1 })
              }
            } else {
              this.setState({ page: this.state.page === 2 ? this.state.page + 3 : this.state.page + 1, errors: [], summaryErrors: [], propertyErrors: [], currentlySelectedService: null, selected_service: -1 })
            }
          }
          else{
            if (this.state.page != 2 || (this.state.page === 2 && !this.state.new_order_process)){
              let selected_service = "";
              let appointment_time = "";
              if (Object.values(this.state.package_attributes).length - Object.values(this.state.appointments).length > 1){
                selected_service = parseInt(Object.keys(this.state.package_attributes).find(n => !this.props.services[n].twilight && !Object.keys(this.state.appointments).includes(n)))
              } else {
                selected_service = parseInt(Object.keys(this.state.package_attributes).find(n => !Object.keys(this.state.appointments).includes(n)))
              }
              if (Object.values(this.state.appointments).length > 0) {
                appointment_time = Object.values(this.state.appointments).find(n => !this.props.services[n.service_id].twilight)?.appointment_time ? new Date(Object.values(this.state.appointments).find(n => !this.props.services[n.service_id].twilight)?.appointment_time) : ""
              }
              let contractorDateSearch = appointment_time || "";
              let contractorTimeSearch = appointment_time ? appointment_time.getHours() + (appointment_time.getMinutes() / 60) : ""
              if (this.props.services[selected_service].twilight && appointment_time){
                const weekday = formatDatetime(appointment_time, 'dddd')
                contractorTimeSearch = Object.keys(this.state.twilight_time[weekday])[0]
              }
              this.setState({ selected_service: selected_service, waiting: true, errors: [], summaryErrors: [], propertyErrors: [], contractorDateSearch: contractorDateSearch, contractorTimeSearch: contractorTimeSearch, page: this.state.page === 3 ? 4 : this.state.page })
              this.props.fetchContractors(selected_service, this.state.zipcode, this.state.contractorSearch, contractorDateSearch, contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot).then((contractors) => { 
                if (Object.values(contractors.contractors).length === 0){
                  this.setState({contractorDateSearch: "", contractorTimeSearch: "", waiting: false})
                } else {
                  this.setState({ waiting: false }) 
                }
              })
            }

            if (this.state.page === 2) {
              if (this.state.new_order_process && Object.values(this.state.visitedServices).length < Object.values(this.state.package_attributes).length) {
                const selectedService = Object.keys(this.state.package_attributes)
                  .map(serviceId => ({
                    id: serviceId,
                    sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
                  }))
                  .filter(service => !this.state.visitedServices[service.id]) // Exclude visited services
                  .reduce((lowest, service) => (service.sort_order < lowest.sort_order ? service : lowest), { sort_order: Infinity })
                  .id || null;


                const updatedVisitedServices = {
                  ...this.state.visitedServices,
                  [selectedService]: true
                };

                this.setState({
                  selected_service: selectedService, currentlySelectedService: this.props.services[selectedService], visitedServices: updatedVisitedServices
                })
              } else {
              this.setState({ page: 3 })
              }
            }
          }
        } else {
          if (this.state.page < 5){
            this.setState({ page: this.state.page + 1, errors: [], summaryErrors: [], propertyErrors: [] })
          }
        }
        // this.debouceScrollTo('#scrollToHere')
      }
    }
  }

  handlePrevious(e) {
    if (e){
      e.preventDefault()
    }

    if (this.state.page === 5) {
      if (this.state.new_order_process) {
        const sorted_visited_appointments = Object.keys(this.state.visitedAppointments).map(serviceId => ({
          id: serviceId,
          sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
        })).sort((a, b) => a.sort_order - b.sort_order)

        let selected_service = sorted_visited_appointments[sorted_visited_appointments.length - 1].id

        this.setState({ page: this.state.page - 1, selected_service: selected_service })
      } else {
        if (this.state.currentlySelectedService || this.state.bundleSelected) {
          this.setState({ page: this.state.page - 1, errors: [], summaryErrors: [], propertyErrors: [] })
        } else {
          this.setState({ page: this.state.page - 3, errors: [], summaryErrors: [], propertyErrors: [] })
        }
      }
    } else if (this.state.page === 4 && (this.state.alacartSelected || (this.state.bundleSelected && !this.state.addonSubServices))){
      this.setState({ page: this.state.page - 2, errors: [], summaryErrors: [], propertyErrors: [], selected_service: -1, currentlySelectedService: null })
      // this.debouceScrollTo('#scrollToHere')
    } else if (this.state.page === 4 && this.state.alacartSelected) {
      if (this.state.new_order_process) {
        const current_service = this.state.selected_service
        const current_appointment = this.state.appointments[current_service]?.appointment_time
        const current_contractor_id = this.state.appointments[current_service]?.contractor_id
        const selected_service = Object.values(this.state.appointments).find(appointment => (appointment.appointment_time != current_appointment || appointment.contractor_id != current_contractor_id) && this.state.visitedAppointments[appointment.service_id])

        if (selected_service) {
          const updatedVisitedAppointments = { ...this.state.visitedAppointments };
          const shared_service_ids = Object.values(this.state.appointments)
            .filter(appointment => appointment.appointment_time === current_appointment && appointment.contractor_id === current_contractor_id)
            .map(appointment => appointment.service_id)
          shared_service_ids.forEach(service_id => delete updatedVisitedAppointments[service_id])
          this.setState({
            selected_service: selected_service.service_id,
            visitedAppointments: updatedVisitedAppointments
          })
        } else {
          const visitedIds = Object.keys(this.state.visitedServices)
            .map(serviceId => ({
              id: serviceId,
              sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
            }))

          const sortedVisitedServices = visitedIds.sort((a, b) => a.sort_order - b.sort_order);
          const previousServiceId = sortedVisitedServices[sortedVisitedServices.length - 1].id

          this.setState({
            selected_service: previousServiceId,
            currentlySelectedService: this.props.services[previousServiceId],
            visitedAppointments: {},
            page: 2
          })
        }
      } else {
        this.setState({ page: 2, errors: [], summaryErrors: [], propertyErrors: [], selected_service: -1, currentlySelectedService: null })
      }
    } else if (this.state.page === 2 && this.state.currentlySelectedService){
      if (this.state.new_order_process && Object.values(this.state.visitedServices).length > 1) {
        const visitedIds = Object.keys(this.state.visitedServices)
          .map(serviceId => ({
            id: serviceId,
            sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
          }))

        const sortedVisitedServices = visitedIds.sort((a, b) => a.sort_order - b.sort_order);

        const currentServiceIndex = sortedVisitedServices.findIndex(service => service.id === this.state.selected_service);

        const previousServiceId = sortedVisitedServices[currentServiceIndex - 1]?.id

        const updatedVisitedServices = { ...this.state.visitedServices };
        delete updatedVisitedServices[this.state.selected_service];

        if (currentServiceIndex === 0){
          this.setState({ errors: [], selected_service: -1, currentlySelectedService: null, propertyErrors: [], summaryErrors: [], visitedServices: {} })
        } else {
        this.setState({
          selected_service: previousServiceId,
          currentlySelectedService: this.props.services[previousServiceId],
          visitedServices: updatedVisitedServices
        });
      }
      } else {
        this.setState({ errors: [], selected_service: -1, currentlySelectedService: null, propertyErrors: [], summaryErrors: [], visitedServices: {} })
      }
    } else {
      const nextPage = this.state.page - 1;
      if (nextPage === 0 && this.state.new_order_process) return;
      this.setState({ page: nextPage, errors: [], summaryErrors: [], propertyErrors: [] })
      // this.debouceScrollTo('#scrollToHere')
    }
  }

  deleteSubService(sub_service) {
    let newState = Object.assign({}, this.state.package_attributes);
    let newStateSubservices = Object.assign({}, this.state.selectedSubservices);
    let newStateAppointments = Object.assign({}, this.state.appointments);
    let newStateVisitedServices = Object.assign({}, this.state.visitedServices);
    let currentlySelectedService = this.state.currentlySelectedService

    delete newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]
    delete newStateSubservices[sub_service.id]

    if (Object.values(newState[sub_service.service_id]["package_sub_services_attributes"]).length === 0) {
      delete newStateAppointments[sub_service.service_id]
      delete newState[sub_service.service_id]
      delete newStateVisitedServices[sub_service.service_id]
      if (currentlySelectedService?.id === sub_service.service_id) {
        currentlySelectedService = null
      }
    }

    this.setState({ package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, visitedServices: newStateVisitedServices, currentlySelectedService: null })
  }

  previewOrder(discount, promo_price, promo_name) {
    let errors = []

    if (this.state.street === "") {
      errors.push([1, "Street can't be blank."])
    }

    if (this.state.city === "") {
      errors.push([2, "City name can't be blank"])
    }

    if (this.state.state === "") {
      errors.push([3, "State can't be blank"])
    }

    if (this.state.zipcode === "") {
      errors.push([4, "Zipcode can't be blank"])
    } else if (this.state.zipcode.length != 5) {
      errors.push([4, "Zipcode must be 5 digits"])
    }

    if (errors.length === 0) {
      this.setState({ promo_price: promo_price, promo_name: promo_name, discount: discount, modalOpen: true })
    } else {
      this.setState({ propertyErrors: errors, summaryErrors: ["Please fill out required fields above."] })
    }
  }

  submitOrder() {
    fetchUnavailability(Object.values(this.state.appointments), this.state.detected_timezone, this.state.street).then((unavailable_appointments) => {
      if (unavailable_appointments.length > 0){
        let newStateAppointments = this.state.appointments
        let newState = this.state.package_attributes
        unavailable_appointments.forEach((unavailable) => {
          delete newStateAppointments[unavailable]
          delete newState[unavailable]["appointment_time"]
          delete newState[unavailable]["contractor_id"]
        })
        this.props.showToast("Photographer is no longer available at this appointment time")
        this.setState({ package_attributes: newState, appointments: newStateAppointments, page: 2, modalOpen: false })
      } else {
        let data = {}
        let address_attributes = {}
        let invites = this.state.emails.toString()
        
        if (this.state.discount > 0 && this.state.account_credit) {
          let coupon_info = { coupon_id: this.state.sub_broker_client ? this.state.account_credit_id : this.props.currentUser?.account_credit?.id, coupon_amount: parseInt(this.state.account_credit) - this.state.discount, coupon_discount_amount: this.state.discount }
          address_attributes = { formatted_address: this.state.formatted_address, county: this.state.county, apartment_number: this.state.apartment, city: this.state.city, region: this.state.state, street1: this.state.street, zip_code: this.state.zipcode, longitude: this.state.longitude, latitude: this.state.latitude, timezone: this.state.detected_timezone }
          data = { coupon_info: coupon_info, client_id: this.state.sub_broker_client ? this.state.sub_broker_client : this.props.currentUser.id, promo_price: this.state.promo_price || null, address_attributes: address_attributes, packages_attributes: this.state.package_attributes, notes: this.state.note, invites: invites, broker_booked: this.props.currentUser.roles.broker }
        } else {
          address_attributes = { formatted_address: this.state.formatted_address, county: this.state.county, apartment_number: this.state.apartment, city: this.state.city, region: this.state.state, street1: this.state.street, zip_code: this.state.zipcode, longitude: this.state.longitude, latitude: this.state.latitude, timezone: this.state.detected_timezone }
          data = { client_id: this.state.sub_broker_client ? this.state.sub_broker_client : this.props.currentUser.id, promo_price: this.state.promo_price || null, address_attributes: address_attributes, packages_attributes: this.state.package_attributes, notes: this.state.note, invites: invites, broker_booked: this.props.currentUser.roles.broker }
        }

        if (this.state.coupon?.id){
          data["discount_coupon_code"] = this.state.coupon.code
        }

        if (this.state.selected_bundle?.id){
          let bundle_price = 0
          let total_price = 0
          let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

          Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
            total_price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
          })

          this.state.selected_bundle.sub_services.forEach(subservice => {
            bundle_price += parseFloat(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
          })
          bundle_price = bundle_price * (1 - (this.state.selected_bundle.percent_discount / 100))


          total_price += Math.ceil(bundle_price)


          if (this.state.coupon?.id) {
            if (this.state.coupon.percentage) {
              total_price -= parseInt(total_price * this.state.coupon.amount / 100)
            } else {
              if (this.state.coupon.amount > price) {
                total_price = 0
              } else {
                total_price -= parseInt(this.state.coupon.amount)
              }
            }
          }

          data["discount_bundle_id"] = this.state.selected_bundle.id
          data["bundle_price"] = total_price
        }

        this.props.submitOrder(data).then(({ project }) => {
          if (project.errors) {
            this.setState({ modalOpen: false })
            this.setState({ errors: project.errors })
            } else {
            this.setState({ page: 6, project: Object.values(project)[0] })
            if (this.state.discount > 0 && this.state.account_credit) {
              this.props.fetchCurrentUser(this.props.currentUser.id)
            }
          }
        })
      }
    })
  }

  handler(newState) {
    return new Promise((resolve, reject) => {
    if (this.state.propertyErrors.length > 0) {
      let errors = []

      const currentState = { ...this.state, ...newState }

      if (currentState.street === "") {
        errors.push([1, "Street can't be blank."])
      }

      if (currentState.city === "") {
        errors.push([2, "City name can't be blank"])
      }

      if (currentState.state === "") {
        errors.push([3, "State can't be blank"])
      }

      if (currentState.zipcode === "") {
        errors.push([4, "Zipcode can't be blank"])
      }

      let combinedState = Object.assign(newState, { propertyErrors: errors, summaryErrors: errors.length > 0 ? ["Please fill out required fields above."] : [] })
      this.setState(combinedState, () => {
        resolve();
      })
    } else {
      this.setState(newState, () => {
        resolve();
      })
    }})
  }

  calculatePrice() {
    let price = 0

    let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

    Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
      price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
    })

    if (this.state.selected_bundle?.id) {
      let bundle = this.state.selected_bundle
      let bundle_price = 0
      bundle.sub_services.forEach(sub_service => {
        bundle_price += parseFloat(this.state.location_pricing[sub_service.id] ? this.state.location_pricing[sub_service.id].price : sub_service.price)
      })

      bundle_price = bundle_price * (1 - (bundle.percent_discount / 100))

      price += Math.ceil(bundle_price)
    }
    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)
    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );

    if (this.state.new_order_process && selectedEligibleServices.length > 1 && selectedEligibleSubServices.length === Object.values(this.state.selectedSubservices).length) {
      if (selectedEligibleServices.length == 2) {
        price -= price * this.state.bundleDiscountWith2 / 100
      } else if (selectedEligibleServices.length == 3) {
        price -= price * this.state.bundleDiscountWith3 / 100
      } else {
        price -= price * this.state.bundleDiscountWith4 / 100
      }
    }

    if (this.state.coupon?.id) {
      if (this.state.coupon.percentage) {
        price -= price * this.state.coupon.amount / 100
      } else {
        price -= this.state.coupon.amount
      }
    }

    price = Math.round(price)
    price -= this.state.discount

    return price
  }

  calculateOriginalPrice() {
    let price = 0

    let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

    Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
      price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
    })

    if (this.state.selected_bundle?.id) {
      let bundle = this.state.selected_bundle
      let bundle_price = 0
      bundle.sub_services.forEach(sub_service => {
        bundle_price += parseFloat(this.state.location_pricing[sub_service.id] ? this.state.location_pricing[sub_service.id].price : sub_service.price)
      })

      bundle_price = bundle_price * (1 - (bundle.percent_discount / 100))

      price += Math.round(bundle_price)
    }

    price = Math.round(price)

    return price
  }

  setAppointmentTime(date, contractor) {
    let newState = this.state.package_attributes
    let newAppointmentState = this.state.appointments
    let newVisitedAppointmentState = this.state.visitedAppointments
    let newMainService = this.state.main_service
    let main = true;
    let contractor_service_ids = {}

    contractor.services.forEach(service => {
      contractor_service_ids[service.id] = true
    })

    Object.values(this.state.appointments).forEach(appointment => {
      if (appointment.contractor.id === this.state.appointments[this.state.selected_service]?.contractor?.id && appointment.appointment_time === this.state.appointments[this.state.selected_service]?.appointment_time && appointment.service_id != this.state.selected_service) {
        newAppointmentState[appointment.service_id] = { service_id: appointment.service_id, contractor: contractor, appointment_time: date }
        newVisitedAppointmentState[appointment.service_id] = true
        newState[appointment.service_id]["appointment_time"] = date
        newState[appointment.service_id]["contractor_id"] = contractor.id
        newState[appointment.service_id]["service_id"] = appointment.service_id
      }
    })

    Object.keys(this.state.package_attributes).forEach(package_service_id => {
      if (contractor_service_ids[package_service_id] && !this.props.services[package_service_id].twilight && !this.props.services[this.state.selected_service].twilight){
        if (!this.state.appointments[package_service_id]){
          newAppointmentState[package_service_id] = { service_id: package_service_id, contractor: contractor, appointment_time: date }
          newVisitedAppointmentState[package_service_id] = true
          newState[package_service_id]["appointment_time"] = date
          newState[package_service_id]["contractor_id"] = contractor.id
          newState[package_service_id]["service_id"] = package_service_id
        }
      }
    })

    if (main === true && !this.props.services[this.state.selected_service].twilight) {
      newMainService[contractor.id] = this.state.selected_service
    }

    newAppointmentState[this.state.selected_service] = { service_id: this.state.selected_service, contractor: contractor, appointment_time: date }
    newVisitedAppointmentState[this.state.selected_service] = true
    newState[this.state.selected_service]["appointment_time"] = date
    newState[this.state.selected_service]["contractor_id"] = contractor.id
    newState[this.state.selected_service]["service_id"] = this.state.selected_service

    this.setState({ package_attributes: newState, appointments: newAppointmentState, main_service: newMainService, summaryErrors: [], visitedAppointments: newVisitedAppointmentState })
  }

  render() {

    let icon = ""
    let popoutModal = ""

    const btnClass = `signupFormButtons${this.props.isLargeScreen ? "" : " createProjectHomePageSignupFormButtons"}`

    let next_percentage_amount = 0

    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)
    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );

    if (this.state.new_order_process && selectedEligibleSubServices.length === Object.values(this.state.selectedSubservices).length) {
      if (selectedEligibleServices.length == 1) {
        next_percentage_amount = this.state.bundleDiscountWith2
      } else if (selectedEligibleServices.length == 2) {
        next_percentage_amount = this.state.bundleDiscountWith3
      } else if (selectedEligibleServices.length == 3) {
        next_percentage_amount = this.state.bundleDiscountWith4
      }
    }

    const nextTierUpsell = (() => {
      if (!this.state.new_order_process || !this.state.bundleDiscountWith2) return null
      const { bundleDiscountWith2: with2, bundleDiscountWith3: with3, bundleDiscountWith4: with4 } = this.state
      const count = selectedEligibleServices.length
      const currentDiscount = count >= 4 ? with4 : count === 3 ? with3 : count === 2 ? with2 : 0
      for (const [needed, pct] of [[2, with2], [3, with3], [4, with4]]) {
        if (needed > count && pct > currentDiscount) return { servicesNeeded: needed - count, discount: pct }
      }
      return null
    })()

    let price = this.calculatePrice()
    let new_price = this.calculatePrice()
    let original_price = this.calculateOriginalPrice()
    let savings = original_price - new_price

    // let icon = <div key="2" onClick={() => this.props.history.goBack()}><i className="fas fa-arrow-left mainIcon createProjectIcon"></i></div>


    let modal = ""

    if (this.state.modalOpen && this.props.currentUser) {
      modal = <CreateProjectModal changeParentState={this.handler} new_order_process={this.state.new_order_process} price={price} location_pricing={this.state.location_pricing} coupon={this.state.coupon} selected_bundle={this.state.selected_bundle} promo_price={this.state.promo_price} firm={this.state.firm} promo_name={this.state.promo_name} sub_broker_client={this.state.sub_broker_client} client_role={this.state.client_role} street={this.state.street} city={this.state.city} state={this.state.state} formatted_address={this.state.formatted_address} apartment={this.state.apartment} zipcode={this.state.zipcode} discount={this.state.discount} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} isLargeScreen={this.props.isLargeScreen} appointments={this.state.appointments} submitOrder={this.submitOrder} client_timezone={this.state.client_timezone}  />
    } else if (this.state.modalOpen) {
      modal = <AccountRequiredModal changeParentState={this.handler} />
    } else if (this.state.contractorModalOpen) {
      modal = <ContractorCalendarModal photographer={this.state.photographer}
        setAppointmentTime={this.setAppointmentTime}
        appointments={this.state.appointments}
        selectedService={this.state.selected_service}
        detected_timezone={this.state.detected_timezone}
        client_timezone={this.state.client_timezone}
        street={this.state.street}
        long_shoot={this.state.long_shoot}
        changeSelected={() => this.setState({ contractorModalOpen: false })}
        isLargeScreen={this.props.isLargeScreen} />
    } else if (this.state.chooseTimeModalOpen) {
      modal = <ChooseTimeModal changeParentState={this.handler} currentUser={this.props.currentUser} detected_timezone={this.state.detected_timezone || this.state.client_timezone || this.props.currentUser.timezone} selectedService={this.state.selected_service} appointments={this.state.appointments} package_attributes={this.state.package_attributes} time_slots={this.props.services[this.state.selected_service]?.twilight ? this.state.twilight_time : this.state.time_slots} contractorDateSearch={this.state.contractorDateSearch} contractorTimeSearch={this.state.contractorTimeSearch} />
    } else if (this.state.bundleReplacedModalOpen) {
      modal = <BundleReplacedModal changeParentState={this.handler} />
    }

    let component = "";
    let componentClosed1 = "";
    let componentClosed2 = "";
    let componentClosed6 = "";
    let componentClosed3 = "";
    let componentClosed4 = "";
    let componentClosed5 = "";
    let buttons = "";
    let button2 = "";

    let order_summary = <OrderSummaryComponent changeParentState={this.handler} new_order_process={this.state.new_order_process} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} location_pricing={this.state.location_pricing} user_emails={this.state.user_emails} users={this.state.users} assigned_user={this.state.sub_broker_client} sub_broker_client_info={this.state.sub_broker_client_info} coupon={this.state.coupon} page={this.state.page} emails={this.state.emails} note={this.state.note} services={this.props.services} promos={this.state.promos} package_attributes={this.state.package_attributes} deleteSubService={this.deleteSubService} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} appointments={this.state.appointments} previewOrder={this.previewOrder} currentUser={this.props.currentUser} formatted_address={this.state.formatted_address} street={this.state.street} city={this.state.city} state={this.state.state} apartment={this.state.apartment} zipcode={this.state.zipcode} selected_bundle={this.state.selected_bundle} sub_broker_client={this.state.sub_broker_client} client_timezone={this.state.client_timezone} />
    if (this.state.page === 0) {
      componentClosed1 = ""
      componentClosed2 = ""
      componentClosed3 = <LocationComponent changeParentState={this.handler} createProjectLoggedIn={true} page={this.state.page} minimize={true} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} />
      componentClosed4 = <ServicesSelectionComponent changeParentState={this.handler} currentUser={this.props.currentUser} selectedEligibleSubServices={selectedEligibleSubServices} selectedEligibleServices={selectedEligibleServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} previouslyChosen={this.state.previouslyChosen} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} minimize={true} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} new_order_process={this.state.new_order_process} />
      componentClosed5 = <PhotographerSelectionComponent new_order_process={this.state.new_order_process} long_shoot={this.state.long_shoot} visitedAppointments={this.state.visitedAppointments} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone} changeParentState={this.handler} createProjectVersion2={true} contractorTimeSearch={this.state.contractorTimeSearch} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} contractorDateSearch={this.state.contractorDateSearch} previouslyChosen={this.state.previouslyChosen} page={this.state.page} waiting={this.state.waiting} minimize={true} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} currentUser={this.props.currentUser} />
      component = <ServiceChoiceComponent changeParentState={this.handler} new_order_process={this.state.new_order_process} handleNext={this.handleNext} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} />
      buttons = <div className={btnClass}>
        {/* <div className="signupFormNext" onClick={this.handleNext}>Next Step</div> */}
      </div>
    } else if (this.state.page === 1) {
      componentClosed1 = !this.state.new_order_process ? <ServiceChoiceComponent changeParentState={this.handler} handleNext={this.handleNext} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} minimize={true} /> : ""
      component = <LocationComponent changeParentState={this.handler} createProjectLoggedIn={this.props.isLargeScreen} minimize={false} page={this.state.page} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} />
      componentClosed3 = <ServicesSelectionComponent changeParentState={this.handler} currentUser={this.props.currentUser} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} previouslyChosen={this.state.previouslyChosen} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} minimize={true} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} new_order_process={this.state.new_order_process} />
      componentClosed4 = <PhotographerSelectionComponent changeParentState={this.handler} long_shoot={this.state.long_shoot} new_order_process={this.state.new_order_process} visitedAppointments={this.state.visitedAppointments} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone} currentUser={this.props.currentUser} createProjectVersion2={true} contractorTimeSearch={this.state.contractorTimeSearch} contractorDateSearch={this.state.contractorDateSearch} previouslyChosen={this.state.previouslyChosen} minimize={true} page={this.state.page} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} waiting={this.state.waiting} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
      buttons = <div className={btnClass}>
        {!this.state.new_order_process && <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>

      if (this.state.goingBackToAddress) {
        buttons = <div className={btnClass}>
          <div className="signupFormNext orderSummaryButton" onClick={this.handleNext}>Order Summary</div>
        </div>
      }
    } else if (this.state.page === 2) {
      componentClosed1 = !this.state.new_order_process ? <ServiceChoiceComponent changeParentState={this.handler} handleNext={this.handleNext} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} minimize={true} /> : ""
      componentClosed2 = <LocationComponent changeParentState={this.handler} createProjectLoggedIn={true} page={this.state.page} minimize={true} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} />
      componentClosed4 = <PhotographerSelectionComponent changeParentState={this.handler} long_shoot={this.state.long_shoot} new_order_process={this.state.new_order_process} visitedAppointments={this.state.visitedAppointments} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone} currentUser={this.props.currentUser} createProjectVersion2={true} contractorTimeSearch={this.state.contractorTimeSearch} contractorDateSearch={this.state.contractorDateSearch} previouslyChosen={this.state.previouslyChosen} page={this.state.page} waiting={this.state.waiting} minimize={true} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
      component = <ServicesSelectionComponent changeParentState={this.handler} currentUser={this.props.currentUser} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} loading={this.state.loading} previouslyChosen={this.state.previouslyChosen} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} bundleLoading={this.state.bundleLoading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} new_order_process={this.state.new_order_process} />
      if (this.props.isLargeScreen) {
        buttons = <div className={btnClass}>
          {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 5, summaryErrors: [] })}>Order Summary</div> : <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
          <div className="signupFormNext" id="bundleScroll" onClick={this.handleNext}>Next Step</div>
        </div>
      } else {
        buttons = <div className={btnClass}>
          {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 5, summaryErrors: [] })}>Checkout</div> : <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
          <div className="signupFormNext" id="bundleScroll" onClick={this.handleNext}>Next Step</div>
        </div>
      }
    } else if (this.state.page === 3){
      if (this.state.alacartSelected){
        componentClosed1 = !this.state.new_order_process ? <ServiceChoiceComponent changeParentState={this.handler} handleNext={this.handleNext} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} minimize={true} /> : ""
        componentClosed2 = <LocationComponent changeParentState={this.handler} createProjectLoggedIn={true} page={this.state.page} minimize={true} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} />
        component = <ServicesSelectionComponent changeParentState={this.handler} currentUser={this.props.currentUser} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} previouslyChosen={this.state.previouslyChosen} loading={this.state.loading} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} bundleLoading={this.state.bundleLoading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} new_order_process={this.state.new_order_process} />
        if (this.props.isLargeScreen) {
          buttons = ""
        } else {
          buttons = <div className={btnClass}>
            {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 5, summaryErrors: [] })}>Checkout</div> : <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
            <div className="signupFormNext" id="bundleScroll" onClick={this.handleNext}>Next Step</div>
          </div>
        }
        if (this.props.isLargeScreen) {
          modal = <AddMoreServicesHomepageModal handleNext={this.handleNext} new_order_process={this.state.new_order_process} percentage_amount={next_percentage_amount} changeParentState={this.handler} services={Object.values(this.props.services)} orderedPackages={this.state.package_attributes} />
        } else {
          popoutModal = <AddMoreServicesHomepageModal handleNext={this.handleNext} new_order_process={this.state.new_order_process} percentage_amount={next_percentage_amount} changeParentState={this.handler} services={Object.values(this.props.services)} orderedPackages={this.state.package_attributes} />
        }
      } else {
        componentClosed1 = <ServiceChoiceComponent changeParentState={this.handler} handleNext={this.handleNext} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} minimize={true} />
        componentClosed2 = <LocationComponent changeParentState={this.handler} createProjectLoggedIn={true} page={this.state.page} minimize={true} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} />
        componentClosed4 = <PhotographerSelectionComponent changeParentState={this.handler} long_shoot={this.state.long_shoot} new_order_process={this.state.new_order_process} visitedAppointments={this.state.visitedAppointments} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone} currentUser={this.props.currentUser} createProjectVersion2={true} contractorTimeSearch={this.state.contractorTimeSearch} contractorDateSearch={this.state.contractorDateSearch} previouslyChosen={this.state.previouslyChosen} page={this.state.page} waiting={this.state.waiting} minimize={true} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
        component = <AddonSubServicesSelectionComponent addonSubservices={this.state.addonSubServices} addonServices={true} location_pricing={this.state.location_pricing} changeParentState={this.handler} loading={this.state.loading} bundleLoading={this.state.bundleLoading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
        buttons = <div className={btnClass}>
          {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 5, summaryErrors: [] })}>Order Summary</div> : <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
          <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
        </div>
      }
    } else if (this.state.page === 4) {
      componentClosed1 = !this.state.new_order_process ? <ServiceChoiceComponent changeParentState={this.handler} handleNext={this.handleNext} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} minimize={true} /> : ""
      componentClosed2 = <LocationComponent changeParentState={this.handler} createProjectLoggedIn={true} page={this.state.page} minimize={true} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} />
      componentClosed6 = <ServicesSelectionComponent changeParentState={this.handler} currentUser={this.props.currentUser} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} previouslyChosen={this.state.previouslyChosen} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} page={this.state.page} minimize={true} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} new_order_process={this.state.new_order_process} />
      component = <PhotographerSelectionComponent handleNext={this.handleNext} long_shoot={this.state.long_shoot} new_order_process={this.state.new_order_process} visitedAppointments={this.state.visitedAppointments} contractorTimeSearch={this.state.contractorTimeSearch} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone} currentUser={this.props.currentUser} createProjectVersion2={true} contractorDateSearch={this.state.contractorDateSearch} changeParentState={this.handler} previouslyChosen={this.state.previouslyChosen} page={this.state.page} waiting={this.state.waiting} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
      buttons = <div className={btnClass}>
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>
    } else if (this.state.page === 5) {
      order_summary = ""
      component = <OrderSummaryComponent changeParentState={this.handler} new_order_process={this.state.new_order_process} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} location_pricing={this.state.location_pricing} user_emails={this.state.user_emails} users={this.state.users} sub_broker_client={this.state.sub_broker_client} sub_broker_client_info={this.state.sub_broker_client_info} assigned_user={this.state.sub_broker_client} coupon={this.state.coupon} checkout={true} modalCheckout={!this.props.isLargeScreen} emails={this.state.emails} note={this.state.note} page={this.state.page} services={this.props.services} errors={this.state.summaryErrors} promos={this.state.promos} package_attributes={this.state.package_attributes} deleteSubService={this.deleteSubService} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} appointments={this.state.appointments} previewOrder={this.previewOrder} currentUser={this.props.currentUser} formatted_address={this.state.formatted_address} street={this.state.street} city={this.state.city} state={this.state.state} apartment={this.state.apartment} zipcode={this.state.zipcode} selected_bundle={this.state.selected_bundle} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone} />
      if (this.props.isLargeScreen) {
        buttons = ""
      } else {
        buttons = <div className={btnClass}>
          <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
          <div className="signupFormNext checkoutModalButton" onClick={() => {
            const currentPrice = Math.max(this.calculatePrice(), 0)
            const creditDiscount = Math.min(this.state.account_credit || 0, currentPrice)
            this.previewOrder(creditDiscount, this.state.promo_price, this.state.promo_name)
          }}>Checkout</div>
        </div>
      }
    } else if (this.state.page === 6) {
      component = ""
      modal = <ProjectCreatedModal project={this.state.project} changeParentState={this.handler} detected_timezone={this.state.detected_timezone} client_timezone={this.state.client_timezone}/>
    }

    if (!this.props.isLargeScreen) {
      document.body.style.overflow = 'hidden'
      if (modal) return modal
      return (
        <div className="modal-background create-project-homepage-modal">
          <Helmet><title>Book Photoshoot</title></Helmet>
          <div className="orderpreviewModal addServiceModal" id="createProjectHomepageModal">
            <div className="orderPreviewModalComponent">
              <div style={{ position: "relative", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
            <div className="addServiceModalContent" id={this.state.page === 5 ? "removePaddingTop" : ""} ref={this.modalContentRef}>
                {!this.state.goingBackToAddress && (
                  <div onClick={() => {
                    const initialPage = this.state.new_order_process ? 1 : 0
                    if (this.state.page <= initialPage) {
                      this.props.history.push('/dashboard')
                    } else {
                      this.handlePrevious()
                    }
                  }} className="modalCloseButton modalCloseButtonHomepage modalCloseButtonCreateProject">
                    <CloseIcon />
                  </div>
                )}
                {popoutModal}
                <div>
                  <div id="scrollToHere"></div>
                  <div id="scrollToHereNew"></div>
                </div>
                {this.state.errors.length > 0 && (
                  <div className="alert alert-danger mt-4">{this.state.errors.join('. ')}</div>
                )}
                {component}
              </div>
              <ScrollArrows scrollRef={this.modalContentRef} />
            </div>
              {this.state.page !== 6 && (
                <div className="modalFooter modalFooterHomepageCreateProject">
                  {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4) && this.state.new_order_process && (
                    <div className="homepageModalTotalMobile">
                      {savings > 0 ? (
                        <div className="d-flex align-items-center">
                          <div className="newPriceMargin">${new_price.toFixed(0)}</div>
                          <div className="savingsPriceOrderSummary newPriceMargin">$<span className="diagonalStrike">{original_price.toFixed(0)}</span></div>
                        </div>
                      ) : (
                        <div className="newPriceMargin">${price}</div>
                      )}
                    </div>
                  )}
                  <div className="homepageModalTotalGroup">
                    {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4) && this.state.new_order_process && (
                      <div className="homepageModalTotal">
                        {savings > 0 ? (
                          <div className="d-flex align-items-center">
                            <div className="newPriceMargin">${new_price.toFixed(0)}</div>
                            <div className="savingsPriceOrderSummary newPriceMargin">$<span className="diagonalStrike">{original_price.toFixed(0)}</span></div>
                          </div>
                        ) : (
                          <div className="newPriceMargin"> ${price}</div>
                        )}
                      </div>
                    )}
                    <div className="modalFooterProgress modalFooterProgressCreateProject">
                      {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4) && this.state.new_order_process && this.state.bundleDiscountWith2 > 0 && (
                        <div className="homepageModalSavings" id="savingsPriceText">
                          {nextTierUpsell
                            ? (nextTierUpsell.servicesNeeded === 1 ? `Add 1 more service to save ${nextTierUpsell.discount}%` : selectedEligibleServices.length === 0 ? `Add ${nextTierUpsell.servicesNeeded}+ services to save ${nextTierUpsell.discount}%` : `Add ${nextTierUpsell.servicesNeeded} more services to save ${nextTierUpsell.discount}%`)
                            : savings > 0
                              ? `${selectedEligibleServices.length >= 4 ? this.state.bundleDiscountWith4 : selectedEligibleServices.length === 3 ? this.state.bundleDiscountWith3 : this.state.bundleDiscountWith2}% bundle discount applied ✓`
                              : null}
                        </div>
                      )}
                    </div>
                  </div>
                  {buttons}
                </div>
              )}
            </div>
            <div className="modalMobilePushup"></div>
          </div>
        </div>
      )
    }

    return (
      <div className="createProjectMainContainer">
        <Helmet><title>Book Photoshoot</title></Helmet>
        {modal}
        {/* <div className="settingsPageHeading createProjectPageHeading">
          {icon}
          <span className="dashboardSubHeading">{projectText}</span>
        </div> */}

        <div className="projectsIndexPageHeading createProjectsIndexPageHeading">
          <div className="dashboardSubHeading">Book Photoshoot</div>
          <div className="mobileLogo"><img src={smallMobileLogo} /></div>
        </div>

        {this.state.errors.length > 0 && (
          <div className="alert alert-danger mt-4">{this.state.errors.join('. ')}</div>
        )}

        <div className="createProjectGroupings">
          <div className="createProjectGroup1">
            {componentClosed1}
            {componentClosed2}
            {componentClosed6}
            <div>
              <div id="scrollToHere"></div>
            </div>
            {component}
            {buttons}
            {componentClosed3}
            {componentClosed4}
            {componentClosed5}
          </div>
          <div className="createProjectGroup2">
            {order_summary}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(CreateProjectMain2);